<template>
  <div>
    <b-modal id="modalEdiStreets" ref="modalEdiStreets" :title="$t('New street')" hide-footer>
      <div v-if="editItem">
        <b-form-group v-if="editItem.street_id" label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.street_id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Country')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.country"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Province/State')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.region"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.city"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Street')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.street"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEdiStreets')"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      let response = this.editItem.street_id !== 0
        ? this.$store.dispatch('ReferenceBooks/UPDATE_STREETS', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_STREETS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_STREETS')
          this.$refs.modalEdiStreets.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/streets/editModal.vue